'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emotion = require('emotion');

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Assistive text to describe visual elements. Hidden for sighted users.
const A11yText = props => _react2.default.createElement('span', _extends({
  className: (0, _emotion.css)({
    zIndex: 9999,
    border: 0,
    clip: 'rect(1px, 1px, 1px, 1px)',
    height: 1,
    width: 1,
    position: 'absolute',
    overflow: 'hidden',
    padding: 0,
    whiteSpace: 'nowrap',
    backgroundColor: 'red',
    color: 'blue'
  })
}, props));

exports.default = A11yText;